import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import logo from "../assets/logo.png";
import "./NavigationBar.css";

const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavLinkClick = () => setExpanded(false);

  return (
    <Navbar
      bg="light"
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      className="shadow-sm py-0 custom-navbar"
    >
      <Container className="d-flex justify-content-between align-items-center">
        {/* Logo + Company Name */}
        <Navbar.Brand
          as={HashLink}
          smooth
          to="/#home"
          className="d-flex align-items-center gap-1 flex-shrink-1 navbar-brand-custom"
          onClick={handleNavLinkClick}
        >
          <img src={logo} alt="Ontario Home Renovations" className="logo-img" />
          <span className="brand-text">Ontario Home Renovations</span>
        </Navbar.Brand>

        {/* Toggle button */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        {/* Navbar links */}
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="me-3">
            <Nav.Link
              as={HashLink}
              smooth
              to="/#home"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={HashLink}
              smooth
              to="/#services"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              Services
            </Nav.Link>
            <Nav.Link
              as={HashLink}
              smooth
              to="/#process"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              Process
            </Nav.Link>
            <Nav.Link
              as={HashLink}
              smooth
              to="/#contact"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              Contact
            </Nav.Link>
            <Nav.Link
              as={HashLink}
              smooth
              to="/about"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              About Us
            </Nav.Link>
            <Nav.Link
              href="https://vsco.co/ontario-home-renovations/gallery"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link-custom"
              onClick={handleNavLinkClick}
            >
              Gallery
            </Nav.Link>
          </Nav>

          <Button
            as="a"
            href="https://cal.com/onhomereno"
            target="_blank"
            rel="noopener noreferrer"
            className="quote-btn"
          >
            Get Quote
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
